export const NAVIGATION_TRANSLATION = {
    'SIDER.HEADER.WORKSPACE': 'Spațiu de lucru',
    'SIDER.LINK.CALCULATIONS': 'Calcule',
    'SIDER.LINK.DOCUMENTS': 'Documente',
    'SIDER.HEADER.ADMINISTRATION': 'Administrare',
    'SIDER.LINK.COMPANIES': 'Companii',
    'SIDER.LINK.USERS': 'Utilizatori',
    'SIDER.LINK.CLIENTS': 'Clienți KPMG',
    'SIDER.LINK.ADMINS': 'Administratori KPMG',
    'SIDER.MESSAGE.PRODUCT': 'un produs',
    'SIDER.MESSAGE.COPYRIGHT': '© 2019-2024 KPMG Advisory SRL, o companie românească cu raspundere limitată și o firmă membră a rețelei KPMG a firmelor membre independente afiliate la KPMG International Cooperative („KPMG International”), o entitate elvețiană. Toate drepturile rezervate.',
    'HEADER.BUTTON.LOGOUT': 'Deloghează',
    'LINK.HISTORICAL_MODULE': 'Modul istoric',
    'SIDER.MESSAGE.VERSION': "v3.1"
};
